import i18n from '@/libs/i18n'
import useEntityCrud from '@/composable/useEntityCrud'
import useEntityHelper from '@/composable/useEntityHelper'
import useErrorManager from '@/composable/useErrorManager'

export default function useArticlesList() {
  const MODULE_NAME = 'testimonials'
  const ENDPOINT = 'testimonials'

  const { getAlt } = useEntityHelper()
  function convertResource(resource, selectedLang) {
    return {
      ...resource,
      name: resource.name[selectedLang],
      content: resource.content[selectedLang],
      user: resource.userId,
      imageFileId: resource.imageFileId,
      lang: selectedLang,
      imageFileIdAlt: getAlt('imageFileId', resource, selectedLang),
      testimonialLink: { name: 'pages-testimonials-edit', params: { id: resource._id, lang: selectedLang } },
    }
  }
  const entity = useEntityCrud(MODULE_NAME, ENDPOINT, convertResource)

  const errorManager = useErrorManager()

  // Table Handlers
  const tableColumns = [
    {
      key: 'name', label: i18n.t('general.name'), type: 'textImage', textKey: 'name', imageKey: 'imageFileId', linkKey: 'testimonialLink',
    },
    { key: 'priority', label: i18n.t('testimonials.priority') },
    { key: 'isActive', label: i18n.t('testimonials.isActive') },
    {
      key: 'createdAt', label: i18n.t('general.createdAt'), type: 'dateTime', sortable: true,
    },
    {
      key: 'updatedAt', label: i18n.t('general.updatedAt'), type: 'dateTime', sortable: true,
    },
    { key: 'actions', label: i18n.t('general.actions'), sortable: false },
  ]

  return {
    ...entity,
    convertResource,
    errorManager,
    tableColumns,
  }
}
